/**
 * Resumen del estado de activación de la OT ligada a un agendamiento de visita.
 * Lo entrega el backend en `agendamiento.resumen_activacion` (una sola query por
 * fila) para que "Calidad de Visitas" muestre si la activación está pendiente
 * SIN tener que abrir el detalle de cada visita.
 */
export type ResumenActivacionVisita = {
  estado_activacion?: string | null;
  estado_orden_trabajo?: string | null;
  requiere_cambio_ont?: boolean | null;
} | null;

export type ActivacionVisitaInfo = {
  /** Hay OT ligada (el técnico ya inició la visita). */
  hasOt: boolean;
  /** Etiqueta corta para el chip. */
  label: string;
  color: "default" | "success" | "warning" | "error" | "info";
  /** true si la activación está pendiente de gestionar (requiere ONT y aún EN ESPERA). */
  pendiente: boolean;
};

/**
 * Deriva el estado de activación mostrable de una fila de agendamiento (visita).
 * Reglas:
 *  - Sin OT → "Sin OT".
 *  - GESTIONADA / REALIZADO ACTIVACION → "Gestionada".
 *  - RECHAZADA → "Rechazada".
 *  - No requiere cambio de ONT → "No requiere" (no hay activación que gestionar).
 *  - Requiere ONT y sigue EN ESPERA / PENDIENTE_* → "Pendiente".
 */
export function infoActivacionVisita(row: any): ActivacionVisitaInfo {
  const r = (row?.resumen_activacion || null) as ResumenActivacionVisita;
  if (!r) {
    return { hasOt: false, label: "Sin OT", color: "default", pendiente: false };
  }
  const estado = (r.estado_activacion || "").toString().toUpperCase();
  const requiereOnt = r.requiere_cambio_ont === true;

  if (estado === "GESTIONADA" || estado === "REALIZADO ACTIVACION") {
    return { hasOt: true, label: "Gestionada", color: "success", pendiente: false };
  }
  if (estado === "RECHAZADA") {
    return { hasOt: true, label: "Rechazada", color: "error", pendiente: false };
  }
  if (!requiereOnt) {
    return { hasOt: true, label: "No requiere", color: "default", pendiente: false };
  }
  // Requiere cambio de ONT y todavía no se gestiona (EN ESPERA / PENDIENTE_*).
  return { hasOt: true, label: "Pendiente", color: "warning", pendiente: true };
}
